import { useEffect, useRef } from 'react';

/**
 * Hook to enable object-fit polyfill when needed.
 * @returns {React.MutableRefObject<unknown> | React.RefObject<unknown>}
 */
const useObjectFit = () => {
  const imgRef = useRef();

  useEffect(() => {
    if ('objectFit' in document.documentElement.style) {
      return;
    }

    import('object-fit-images').then(({ default: objectFitImages }) => {
      objectFitImages(imgRef.current);
    });
  });

  return imgRef;
};

export default useObjectFit;
